import axiosInstance from "Api";
import TextLimit from "Api/TextLimit";
import React, { createContext, useState, useContext, useEffect } from "react";
import useSWR from "swr";
import { useApiMutation } from "services/useApiMutation";

const AbsentsContext = createContext();

export const AbsentsProvider = ({ children }) => {
	
	const [absentsData, setAbsentsData] = useState([]);
	const [error, setError] = useState(null);
	const [params, setParams] = useState({
		schoolId: null,
		communityId: null,
	});
	const { trigger: updateAbsentTrigger } = useApiMutation();

	const {
		data: absentsResponse,
		mutate: mutateAbsents,
	} = useSWR(
		params.schoolId && params.communityId
			? ["absents-list", params.schoolId, params.communityId]
			: null,
		([, schoolId, communityId]) =>
			axiosInstance.get(
				`absents-list?iSchoolId=${schoolId}&iCommunityId=${communityId}`
			)
	);

	useEffect(() => {
		if (!absentsResponse?.data?.data) return;

		const userData = absentsResponse.data.data.map((element) => ({
			...element,
			name: TextLimit.AfwezigeLimitOptionOne(
				element.vFirstName,
				element.vMiddleName,
				element.vLastName
			),
			birthdate: element.dBirthdate,
			city: element.vCity,
		}));

		setAbsentsData(userData);
	}, [absentsResponse]);


	const sortAbsents = (absents) => {
		return absents.sort((a, b) => {
			if (b.bSelected === a.bSelected) {
				return a.name.localeCompare(b.name);
			}
			return b.bSelected - a.bSelected;
		});
	};

	const updateLikeStatus = (adminId, isLiked) => {
		setAbsentsData((prevState) => {
			const updatedList = prevState.map((absent) =>
				absent.iAdminId === adminId ? { ...absent, bSelected: isLiked ? 0 : 1 } : absent
			);

			return sortAbsents(updatedList);
		});
	};

	const handleLikeStatus = async (
		adminId,
		schoolId,
		isLiked
	) => {
		const url = `admin-school${isLiked ? "" : "/create"
			}?iSchoolId=${schoolId}&iAdminId=${adminId}`;

		const method = isLiked ? "delete" : "post";

		try {

			updateLikeStatus(adminId, isLiked);

			await updateAbsentTrigger(() =>
				axiosInstance[method](url)
			);

			mutateAbsents();
		} catch (error) {
			console.error(error);
			mutateAbsents();

			setError(error);
		}
	};
const fetchAbsentsList = (schoolId, communityId) => {
    setParams({ schoolId, communityId });
};

	return (
		<AbsentsContext.Provider
			value={{
				absentsData,
				error,
				setAbsentsData,
				updateLikeStatus,
				handleLikeStatus,
				fetchAbsentsList,
				setError,
				setParams,
			}}
		>
			{children}
		</AbsentsContext.Provider>
	);
};

export const useAbsentsContext = () => useContext(AbsentsContext);